import React from 'react';
import { Chip } from '@mui/material';

// Shared status → color mapping so "Active"/"Late"/"Absent" etc. always
// look the same wherever they appear (dashboard, employees, reports).
const STATUS_COLORS = {
    'Active':         { bg: 'rgba(16,185,129,0.15)', color: '#10B981' },
    'On Time':        { bg: 'rgba(16,185,129,0.15)', color: '#10B981' },
    'Checked Out':    { bg: 'rgba(255,255,255,0.08)', color: '#9CA3AF' },
    'Late':           { bg: 'rgba(245,158,11,0.15)', color: '#F59E0B' },
    'Not Logged In':  { bg: 'rgba(239,68,68,0.12)', color: '#EF4444' },
    'Absent':         { bg: 'rgba(239,68,68,0.12)', color: '#EF4444' },
    'Off':            { bg: 'rgba(129,140,248,0.15)', color: '#818CF8' },
    // Productivity rating statuses (LogDetail.log_status)
    'Productive':     { bg: 'rgba(16,185,129,0.15)', color: '#10B981' },
    'UnProductive':   { bg: 'rgba(239,68,68,0.12)', color: '#EF4444' },
    'Neutral':        { bg: 'rgba(245,158,11,0.15)', color: '#F59E0B' },
    'UnRated':        { bg: 'rgba(255,255,255,0.08)', color: '#9CA3AF' },
};

export default function StatusChip({ status }) {
    const c = STATUS_COLORS[status] || { bg: 'rgba(255,255,255,0.08)', color: '#9CA3AF' };
    return (
        <Chip
            label={status || 'Unknown'}
            size="small"
            sx={{ bgcolor: c.bg, color: c.color, fontWeight: 600, border: 'none' }}
        />
    );
}
